/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  PATCH_PARTY_HOST_CAN_INVITE,
  PATCH_PARTY_SEND_METHODS,
} from 'src/actions/eventTemplatesActions';
import {
  SET_LOADING,
  SET_CURRENT_NAVIGATION_TAB,
  GET_PARTY,
  GET_PARTY_SUCCESS,
  GET_PARTY_ERROR,
  DELETE_PARTY,
  DELETE_PARTY_SUCCESS,
  DELETE_PARTY_ERROR, CLEAR_PARTY_WAS_DELETED,
  UPDATE_PARTY,
  UPDATE_PARTY_SUCCESS,
  UPDATE_PARTY_ERROR,
  CREATE_PARTY,
  CREATE_PARTY_SUCCESS,
  CREATE_PARTY_ERROR,
  UPDATE_PARTY_GUEST_MESSAGING,
  UPDATE_PARTY_GUEST_MESSAGING_SUCCESS,
  UPDATE_PARTY_GUEST_MESSAGING_ERROR,
  GET_PARTY_SOURCES,
  GET_PARTY_SOURCES_SUCCESS,
  GET_PARTY_SOURCES_ERROR,
  SET_PARTY_DETAILS_TAB,
  SET_FORM_CREATE_UPDATE_PARTY,
  SET_FORM_UPDATE_PARTY_GUEST_MESSAGING,
  SET_PARTY_GUESTS,
  GET_PARTY_GUESTS,
  GET_PARTY_GUESTS_SUCCESS,
  GET_PARTY_GUESTS_ERROR,
  SET_PARTY_GUESTS_QUERY,
  SET_SELECTED_PARTY_GUESTS,
  SET_PARTY_ORDERS,
  GET_PARTY_ORDERS,
  GET_PARTY_ORDERS_SUCCESS,
  GET_PARTY_ORDERS_ERROR,
  SET_PARTY_ORDERS_QUERY,
  SET_SELECTED_PARTY_ORDERS,
  SET_SELECTED_CONTACTS,
  SET_SELECTED_ORDERS,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  SET_VALUES_FORM_SEND_TEXT,
  SEND_TEXT_MESSAGE,
  SEND_TEXT_MESSAGE_ERROR,
  SEND_TEXT_MESSAGE_SUCCESS,
  SET_VALUES_FORM_ADD_PB_TAG,
  SEND_ADD_TAG_CAMPAIGN,
  SEND_ADD_TAG_CAMPAIGN_ERROR,
  SEND_ADD_TAG_CAMPAIGN_SUCCESS,
  SET_VALUES_FORM_ADD_PARTY_GUEST,
  SEND_ADD_PARTY_GUEST,
  SEND_ADD_PARTY_GUEST_ERROR,
  SEND_ADD_PARTY_GUEST_SUCCESS,
  SEND_REMOVE_PARTY_GUESTS,
  SEND_REMOVE_PARTY_GUESTS_ERROR,
  SEND_REMOVE_PARTY_GUESTS_SUCCESS,
  SET_VALUES_FORM_ADD_PARTY_ORDER,
  SEND_ADD_PARTY_ORDER,
  SEND_ADD_PARTY_ORDER_ERROR,
  SEND_ADD_PARTY_ORDER_SUCCESS,
  SEND_REMOVE_PARTY_ORDERS,
  SEND_REMOVE_PARTY_ORDERS_ERROR,
  SEND_REMOVE_PARTY_ORDERS_SUCCESS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  GET_CONTACTS_LIST,
  GET_CONTACTS_LIST_SUCCESS,
  GET_CONTACTS_LIST_ERROR,
  GET_ORDERS_LIST,
  GET_ORDERS_LIST_SUCCESS,
  GET_ORDERS_LIST_ERROR,
  GET_CONTACT_HOSTED_BY_YOU,
  GET_CONTACT_HOSTED_BY_YOU_SUCCESS,
  GET_CONTACT_HOSTED_BY_YOU_ERROR,
  SET_CONTACT_HOSTED_BY_YOU,
  SET_CONTACT_HOSTED_BY_YOU_SUCCESS,
  SET_CONTACT_HOSTED_BY_YOU_ERROR,
  REPLACE_SYSTEM_GEN_MESSAGE,
  REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
  SET_VALUES_WELCOME_MESSAGE,
  GET_PARTY_TYPES,
  GET_PARTY_TYPES_SUCCESS,
  GET_PARTY_TYPES_ERROR,
  SET_UPDATE_UPDATE_SMART_ACTION_DATES,
  SET_UPDATE_UPDATE_PARTY_TYPE_COMPONENTS,
  SET_FORM_MODIFY_GUESTS,
  MODIFY_GUESTS,
  MODIFY_GUESTS_SUCCESS,
  MODIFY_GUESTS_ERROR,
  GET_ALL_GROUPS_LIST,
  GET_ALL_GROUPS_LIST_SUCCESS,
  GET_ALL_GROUPS_LIST_ERROR,
  SET_VALUES_FORM_ADD_GUESTS_TO_GROUP,
  SEND_ADD_GUESTS_TO_GROUP,
  SEND_ADD_GUESTS_TO_GROUP_SUCCESS,
  SEND_ADD_GUESTS_TO_GROUP_ERROR,
  GET_CUSTOM_FIELDS,
  GET_CUSTOM_FIELDS_SUCCESS,
  GET_CUSTOM_FIELDS_ERROR,
} from 'src/actions/partyDetailsActions';

const initialCurrentNavigationTab = 'details';

const goToOrderDetails = {
  partyId: null,
  wasReturned: false,
  query: {},
};

const partySourcesList = {
  data: [],
  loading: false,
};

const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const formAddPBTag = {
  loading: false,
};

const formAddPartyGuest = {
  loading: false,
  guest: '',
};

const formAddPartyOrder = {
  loading: false,
  order: '',
};

const formRemovePartyGuests = {
  loading: false,
};

const formRemovePartyOrders = {
  loading: false,
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const welcomeMessage = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const partyTypes = {
  partyTypeList: [],
  loading: false,
};

const formModifyGuests = {
  isVisible: false,
  loading: false,
  formData: {
    joinedPartyDateTime: '',
  },
};

const contactHostedByYou = {
  loading: false,
  contactDetail: {
    isSalespersonMobilePhoneEmpty: null,
    shouldCreateContact: null,
    contact: null,
  },
};

const allGroups = {
  groups: [],
  loading: false,
};

const formAddGuestsToGroup = {
  loading: false,
  group: '',
};

const customFields = {
  customFieldsList: [],
  loading: false,
};

const initialState = {
  party: {},
  selectedPartyGuests: [],
  selectedContacts: [],
  selectedPartyOrders: [],
  selectedOrders: [],
  query: {
    sort: {
      table2: 'contact',
      column1: 'lastName',
      column2: 'firstName',
      direction1: 'asc',
      direction2: 'asc',
    },
    page: 1,
    pageSize: 50,
    count: 0,
  },
  ordersQuery: {
    sort: {
      table2: 'orderHeader',
      column1: 'orderDateTime',
      column2: null,
      direction1: 'asc',
      direction2: null,
    }
  },
  partyWasDeleted: false,
  loading: false,
  // there is an issue with variable "loading". A lot of requests used one "loading", conflicted, and I couldn't move it to another object
  loadingPartyGuests: false,
  loadingParty: false,
  currentNavigationTab: initialCurrentNavigationTab,
  goToOrderDetails,
  formCreateUpdateParty: {
    hasUpdatedCustomFields: false,
  },
  partyGuests: [],
  partyGuestsCount: 0,
  // CON-1532 — V2 Event Guests column config (set by GET_PARTY_GUESTS_SUCCESS).
  partyGuestsColumnConfig: null,
  // CON-2026 — activity badges (P1d): the guest ids shown as new while this
  // event's page is open, kept so marking seen does not take the highlight
  // away mid-visit.
  partyGuestsActivityNewIds: [],
  partyGuestsActivityPartyId: null,
  // CON-2036 review — how many guests were new when this visit began (the
  // first answer's unseenTotal; later answers read 0 once it is marked
  // seen), for the "N new since your last visit" chip.
  partyGuestsActivityVisitTotal: 0,
  partyOrders: [],
  partyOrdersCount: 0,
  partySubtotal: 0,
  visibleModalFormNumber: null,
  partySourcesList,
  formSendText,
  formAddPBTag,
  formAddPartyGuest,
  formAddPartyOrder,
  formRemovePartyGuests,
  formRemovePartyOrders,
  welcomeMessage,
  followUpMessages,
  partyTypes,
  updateSmartActionDates: false,
  updatePartyTypeComponents: false,
  formModifyGuests,
  contactHostedByYou,
  formAddGuestsToGroup,
  allGroups,
  customFields,
};

const partyDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_LOADING: {
      return produce(state, (draft) => {
        draft.loading = payload;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case SET_FORM_MODIFY_GUESTS: {
      return produce(state, (draft) => {
        draft.formModifyGuests.formData = payload ? {
          ...state.formModifyGuests.formData,
          ...payload,
        } : formModifyGuests.formData;
      });
    }

    case MODIFY_GUESTS: {
      return produce(state, (draft) => {
        draft.formModifyGuests.loading = true;
      });
    }

    case MODIFY_GUESTS_SUCCESS:
    case MODIFY_GUESTS_ERROR: {
      return produce(state, (draft) => {
        draft.formModifyGuests.loading = false;
      });
    }

    case GET_PARTY: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.loadingParty = true;
      });
    }

    case GET_PARTY_SUCCESS: {
      return produce(state, (draft) => {
        draft.party = payload?.party || {};
        draft.loading = false;
        draft.loadingParty = false;
      });
    }

    // CON-1487 Phase 5 Step 10 — narrow patch dispatched after the
    // Event Templates tab Host Can Invite toggle saves. Keeps the
    // loaded party.hostCanInviteViaConsultantSMS in sync with the
    // DB so the toggle component's optimistic overlay can clear
    // cleanly without visually reverting.
    case PATCH_PARTY_HOST_CAN_INVITE: {
      return produce(state, (draft) => {
        if (draft.party) {
          draft.party.hostCanInviteViaConsultantSMS = !!payload?.hostCanInviteViaConsultantSMS;
        }
      });
    }

    // Three-toggle send methods — combined patch dispatched after
    // SendMethodsCard saves at Event scope. The party PATCH endpoint
    // requires all three fields, so this case always patches all three.
    case PATCH_PARTY_SEND_METHODS: {
      return produce(state, (draft) => {
        if (draft.party) {
          if (payload?.hostCanInviteViaConsultantSMS !== undefined) {
            draft.party.hostCanInviteViaConsultantSMS = !!payload.hostCanInviteViaConsultantSMS;
          }
          if (payload?.hostHasTextingOptions !== undefined) {
            draft.party.hostHasTextingOptions = !!payload.hostHasTextingOptions;
          }
          if (payload?.hostHasEmailOptions !== undefined) {
            draft.party.hostHasEmailOptions = !!payload.hostHasEmailOptions;
          }
          if (payload?.hostCanInviteViaOtherApp !== undefined) {
            draft.party.hostCanInviteViaOtherApp = !!payload.hostCanInviteViaOtherApp;
          }
          // CON-1576 — Host Welcome Video URL saved from the same band
          // (its own PATCH endpoint at Event scope).
          if (payload?.hostWelcomeVideoUrl !== undefined) {
            draft.party.hostWelcomeVideoUrl = payload.hostWelcomeVideoUrl;
          }
        }
      });
    }

    case GET_PARTY_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loadingParty = false;
      });
    }

    case GET_PARTY_SOURCES: {
      return produce(state, (draft) => {
        draft.partySourcesList.loading = true;
      });
    }

    case GET_PARTY_SOURCES_SUCCESS: {
      return produce(state, (draft) => {
        draft.partySourcesList.data = payload || [];
        draft.partySourcesList.loading = false;
      });
    }

    case GET_PARTY_SOURCES_ERROR: {
      return produce(state, (draft) => {
        draft.partySourcesList = { ...partySourcesList };
      });
    }

    case DELETE_PARTY: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_CONTACT_HOSTED_BY_YOU:
    case SET_CONTACT_HOSTED_BY_YOU: {
      return produce(state, (draft) => {
        draft.contactHostedByYou.loading = true;
      });
    }

    case GET_CONTACT_HOSTED_BY_YOU_SUCCESS:
    case SET_CONTACT_HOSTED_BY_YOU_SUCCESS: {
      return produce(state, (draft) => {
        draft.contactHostedByYou.loading = false;
        draft.contactHostedByYou.contactDetail = {
          ...payload || {},
        };
      });
    }

    case GET_CONTACT_HOSTED_BY_YOU_ERROR:
    case SET_CONTACT_HOSTED_BY_YOU_ERROR: {
      return produce(state, (draft) => {
        draft.contactHostedByYou.loading = false;
        draft.contactHostedByYou.contactDetail = {
          ...contactHostedByYou?.contactDetail || {},
        };
      });
    }

    case DELETE_PARTY_SUCCESS: {
      return produce(state, (draft) => {
        draft.party = payload ? initialState.party : state.party;
        draft.loading = false;
        draft.partyWasDeleted = true;
      });
    }

    case DELETE_PARTY_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_PARTY_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.partyWasDeleted = false;
      });
    }

    case CREATE_PARTY:
    case UPDATE_PARTY: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case CREATE_PARTY_SUCCESS:
    case CREATE_PARTY_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    // CON-1888: the two dialog answers apply to the save they were given
    // for. Left set, a Yes rode along on every later ordinary Save.
    case UPDATE_PARTY_SUCCESS:
    case UPDATE_PARTY_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.updatePartyTypeComponents = false;
        draft.updateSmartActionDates = false;
      });
    }

    case UPDATE_PARTY_GUEST_MESSAGING: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_PARTY_GUEST_MESSAGING_SUCCESS:
    case UPDATE_PARTY_GUEST_MESSAGING_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_PARTY_DETAILS_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialState.currentNavigationTab;
      });
    }

    case SET_FORM_CREATE_UPDATE_PARTY: {
      return produce(state, (draft) => {
        draft.formCreateUpdateParty = payload ? {
          ...state.formCreateUpdateParty,
          ...payload,
        } : initialState.formCreateUpdateParty;
      });
    }

    case SET_PARTY_GUESTS: {
      return produce(state, (draft) => {
        draft.partyGuests = payload || [];
        draft.selectedPartyGuests = [];
        draft.selectedContacts = [];
      });
    }

    case GET_PARTY_GUESTS: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.loadingPartyGuests = true;
      });
    }

    case GET_PARTY_GUESTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.partyGuests = payload?.partyGuests || {};
        draft.partyGuestsCount = payload?.count;
        draft.query.count = payload?.count || 0;
        // CON-1532 — V2 Event Guests tab reads this; V1 ignores it.
        // The server resolves it via pagePreferencesService and returns
        // it alongside the rows on every list response.
        draft.partyGuestsColumnConfig = payload?.columnConfig || null;
        draft.loading = false;
        draft.loadingPartyGuests = false;
        if (draft.partyGuestsActivityPartyId !== (payload?.partyId || null)) {
          draft.partyGuestsActivityPartyId = payload?.partyId || null;
          draft.partyGuestsActivityNewIds = [];
          draft.partyGuestsActivityVisitTotal = 0;
        }
        draft.partyGuestsActivityVisitTotal = Math.max(
          draft.partyGuestsActivityVisitTotal || 0,
          Number(payload?.activity?.unseenTotal) || 0,
        );
        (payload?.activity?.newIds || []).forEach((guestId) => {
          if (!draft.partyGuestsActivityNewIds.includes(guestId)) {
            draft.partyGuestsActivityNewIds.push(guestId);
          }
        });

        // CON-1658 — a refetch normally clears the selection, which is right
        // for a page change, filter or search. The refetch after a bulk
        // modify opts out so the user can act on the same guests again.
        //
        // Even then the selection is INTERSECTED with the rows that came
        // back: a guest edited out of the active filter is gone from the
        // table, so keeping its id would leave the bulk bar counting rows
        // that are not on screen.
        if (payload?.keepSelection) {
          const rows = Array.isArray(payload?.partyGuests) ? payload.partyGuests : [];
          const liveIds = new Set(rows.map((r) => r?.id));
          const liveContactIds = new Set(rows.map((r) => r?.contactId));
          draft.selectedPartyGuests = (draft.selectedPartyGuests || [])
            .filter((id) => liveIds.has(id));
          draft.selectedContacts = (draft.selectedContacts || [])
            .filter((id) => liveContactIds.has(id));
        } else {
          draft.selectedPartyGuests = [];
          draft.selectedContacts = [];
        }
      });
    }

    case GET_PARTY_GUESTS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loadingPartyGuests = false;
      });
    }

    case SET_PARTY_GUESTS_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case SET_SELECTED_PARTY_GUESTS: {
      return produce(state, (draft) => {
        draft.selectedPartyGuests = payload || [];
      });
    }

    case SET_PARTY_ORDERS: {
      return produce(state, (draft) => {
        draft.partyOrders = payload || [];
        draft.selectedPartyOrders = [];
        draft.selectedOrders = [];
      });
    }

    case GET_PARTY_ORDERS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_PARTY_ORDERS_SUCCESS: {
      return produce(state, (draft) => {
        draft.partyOrders = payload?.partyOrders || {};
        draft.partyOrdersCount = payload?.count;
        draft.partySubtotal = payload?.subtotal;
        draft.loading = false;
      });
    }

    case GET_PARTY_ORDERS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_PARTY_ORDERS_QUERY: {
      return produce(state, (draft) => {
        draft.ordersQuery = payload ? {
          ...state.ordersQuery,
          ...payload
        } : initialState.ordersQuery;
      });
    }

    case SET_SELECTED_PARTY_ORDERS: {
      return produce(state, (draft) => {
        draft.selectedPartyOrders = payload || [];
      });
    }

    case SET_SELECTED_CONTACTS: {
      return produce(state, (draft) => {
        draft.selectedContacts = payload || [];
      });
    }

    case SET_SELECTED_ORDERS: {
      return produce(state, (draft) => {
        draft.selectedOrders = payload || [];
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case SET_VALUES_FORM_SEND_TEXT: {
      return produce(state, (draft) => {
        draft.formSendText = payload ? {
          ...state.formSendText,
          ...payload,
        } : formSendText;
      });
    }

    case SEND_TEXT_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case SEND_TEXT_MESSAGE_SUCCESS:
    case SEND_TEXT_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_PB_TAG: {
      return produce(state, (draft) => {
        draft.formAddPBTag = payload ? {
          ...state.formAddPBTag,
          ...payload,
        } : formAddPBTag;
      });
    }

    case SEND_ADD_TAG_CAMPAIGN: {
      return produce(state, (draft) => {
        draft.formAddPBTag.loading = true;
      });
    }

    case SEND_ADD_TAG_CAMPAIGN_SUCCESS:
    case SEND_ADD_TAG_CAMPAIGN_ERROR: {
      return produce(state, (draft) => {
        draft.formAddPBTag.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_PARTY_GUEST: {
      return produce(state, (draft) => {
        draft.formAddPartyGuest = payload ? {
          ...state.formAddPartyGuest,
          ...payload,
        } : formAddPartyGuest;
      });
    }

    case SEND_ADD_PARTY_GUEST: {
      return produce(state, (draft) => {
        draft.formAddPartyGuest.loading = true;
      });
    }

    case SEND_ADD_PARTY_GUEST_SUCCESS:
    case SEND_ADD_PARTY_GUEST_ERROR: {
      return produce(state, (draft) => {
        draft.formAddPartyGuest.loading = false;
      });
    }

    case SEND_REMOVE_PARTY_GUESTS: {
      return produce(state, (draft) => {
        draft.formRemovePartyGuests.loading = true;
      });
    }

    case SEND_REMOVE_PARTY_GUESTS_SUCCESS:
    case SEND_REMOVE_PARTY_GUESTS_ERROR: {
      return produce(state, (draft) => {
        draft.formRemovePartyGuests.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_PARTY_ORDER: {
      return produce(state, (draft) => {
        draft.formAddPartyOrder = payload ? {
          ...state.formAddPartyOrder,
          ...payload,
        } : formAddPartyOrder;
      });
    }

    case SEND_ADD_PARTY_ORDER: {
      return produce(state, (draft) => {
        draft.formAddPartyOrder.loading = true;
      });
    }

    case SEND_ADD_PARTY_ORDER_SUCCESS:
    case SEND_ADD_PARTY_ORDER_ERROR: {
      return produce(state, (draft) => {
        draft.formAddPartyOrder.loading = false;
      });
    }

    case SEND_REMOVE_PARTY_ORDERS: {
      return produce(state, (draft) => {
        draft.formRemovePartyOrders.loading = true;
      });
    }

    case SEND_REMOVE_PARTY_ORDERS_SUCCESS:
    case SEND_REMOVE_PARTY_ORDERS_ERROR: {
      return produce(state, (draft) => {
        draft.formRemovePartyOrders.loading = false;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case GET_CONTACTS_LIST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_CONTACTS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.contacts = payload || [];
        draft.loading = false;
      });
    }

    case GET_CONTACTS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_ORDERS_LIST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_ORDERS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.orders = payload || {};
        draft.loading = false;
      });
    }

    case GET_ORDERS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = false;
        draft.welcomeMessage.systemGenMessageReplaced = payload || false;
      });
    }

    case SET_FORM_UPDATE_PARTY_GUEST_MESSAGING: {
      return produce(state, (draft) => {
        draft.formPartyGuestMessaging = payload ? {
          ...state.formPartyGuestMessaging,
          ...payload,
        } : initialState.formPartyGuestMessaging;
      });
    }

    case SET_VALUES_WELCOME_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage = payload ? {
          ...state.welcomeMessage,
          ...payload,
        } : welcomeMessage;
      });
    }

    case GET_PARTY_TYPES: {
      return produce(state, (draft) => {
        draft.partyTypes.loading = true;
      });
    }

    case GET_PARTY_TYPES_SUCCESS:
    case GET_PARTY_TYPES_ERROR: {
      return produce(state, (draft) => {
        draft.partyTypes.loading = false;
        draft.partyTypes.partyTypeList = payload ? [
          ...state.partyTypes.partyTypeList,
          ...payload,
        ] : partyTypes.partyTypeList;
      });
    }

    case SET_UPDATE_UPDATE_SMART_ACTION_DATES: {
      return produce(state, (draft) => {
        draft.updateSmartActionDates = payload;
      });
    }

    case SET_UPDATE_UPDATE_PARTY_TYPE_COMPONENTS: {
      return produce(state, (draft) => {
        draft.updatePartyTypeComponents = payload;
      });
    }

    case GET_ALL_GROUPS_LIST: {
      return produce(state, (draft) => {
        draft.allGroups.loading = true;
      });
    }

    case GET_ALL_GROUPS_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.allGroups.loading = false;
        draft.allGroups.groups = payload || [];
      });
    }

    case GET_ALL_GROUPS_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.allGroups.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_GUESTS_TO_GROUP: {
      return produce(state, (draft) => {
        draft.formAddGuestsToGroup = payload ? {
          ...state.formAddGuestsToGroup,
          ...payload,
        } : formAddGuestsToGroup;
      });
    }

    case SEND_ADD_GUESTS_TO_GROUP: {
      return produce(state, (draft) => {
        draft.formAddGuestsToGroup.loading = true;
      });
    }

    case SEND_ADD_GUESTS_TO_GROUP_SUCCESS:
    case SEND_ADD_GUESTS_TO_GROUP_ERROR: {
      return produce(state, (draft) => {
        draft.formAddGuestsToGroup.loading = false;
      });
    }

    case GET_CUSTOM_FIELDS: {
      return produce(state, (draft) => {
        draft.customFields.loading = true;
      });
    }

    case GET_CUSTOM_FIELDS_SUCCESS:
    case GET_CUSTOM_FIELDS_ERROR: {
      return produce(state, (draft) => {
        draft.customFields.loading = false;
        draft.customFields.customFieldsList = payload?.data
          ? payload.data
          : initialState.customFields.customFieldsList;
      });
    }

    default: {
      return state;
    }
  }
};

export default partyDetailsReducer;
